<template>
    <div v-if="filteredBy">
        {{ $t('common.filtered-by.label') }}:

        <strong>
            {{ filteredBy }}
            <q>{{ related.name }}</q>
        </strong>

        <a :href="action">[{{ $t('common.filtered-by.clear') }}]</a>
    </div>
</template>

<script>
import URI from 'urijs';

const uri = URI(window.location.href);
const queryMap = uri.query(true);

export default {
    name: 'FilteredByRelated',

    props: {
        filteredBy: {type: String, default: null},
        related: {type: Object, default: null},
    },

    computed: {
        action() {
            const queries = Object.keys(queryMap)
                .filter((key) => !/^filter_by/.test(key))
                .reduce((queries, key) => {
                    queries[key] = queryMap[key];

                    return queries;
                }, {});

            return uri.query(queries).toString();
        },
    },
};
</script>
